import React, { useState, useEffect } from "react";
import "./ProductPage.css";
import FeatureCardCom from "./twoText";

const BigImages = [
    "https://elecarerecord.blob.core.windows.net/img/1.png", 
    "https://elecarerecord.blob.core.windows.net/img/2.png",
    "https://elecarerecord.blob.core.windows.net/img/3.png",
    "https://elecarerecord.blob.core.windows.net/img/4.png", 
    "https://elecarerecord.blob.core.windows.net/img/5.png",
    "https://elecarerecord.blob.core.windows.net/img/6.png",
    "https://elecarerecord.blob.core.windows.net/img/7.png", 
    "https://elecarerecord.blob.core.windows.net/img/8.png", 
  ];

  
const SmallImages = [
    "https://elecarerecord.blob.core.windows.net/img/small1.png",
    "https://elecarerecord.blob.core.windows.net/img/small2.png",
    "https://elecarerecord.blob.core.windows.net/img/small3.png",
    "https://elecarerecord.blob.core.windows.net/img/small4.png",
    "https://elecarerecord.blob.core.windows.net/img/small5.png",
    "https://elecarerecord.blob.core.windows.net/img/small6.png",
    "https://elecarerecord.blob.core.windows.net/img/small7.png",
    "https://elecarerecord.blob.core.windows.net/img/small8.png",
  ];

const icon = ["/clear.svg", "/phone.svg", "/battery.svg", "/aid.png", "/hear.svg"];


const ProductPageCom = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [images, setImages] = useState([]);
  // 切换到下一张图片
  const handleNext = () => {
    setCurrentIndex((currentIndex + 1) % images.length);
  };

  // 切换到上一张图片
  const handlePrev = () => {
    setCurrentIndex((currentIndex - 1 + images.length) % images.length);
  };

  // 直接切换到某张图片
  const handleSelect = (index) => {
    setCurrentIndex(index);
  };

  const updateImages = () => {
    const width = window.innerWidth;

    // 根据屏幕宽度设置不同的图片数组
    if (width > 768) {
      setImages(BigImages);
    } else {
      setImages(SmallImages);
    }
  };

    // 预加载图片逻辑
  useEffect(() => {
    const preloadedImages = [];
    let loadedCount = 0;

    const width = window.innerWidth;

    // 根据屏幕宽度设置不同的图片数组
    if (width > 768) {
      BigImages.forEach((path, index) => {
        const img = new Image();
        img.src = path;
        img.onload = () => {
          loadedCount += 1;
          preloadedImages[index] = img;
        };
      });
    } else {
      SmallImages.forEach((path, index) => {
        const img = new Image();
        img.src = path;
        img.onload = () => {
          loadedCount += 1;
          preloadedImages[index] = img;
        };
      });
    }
  }, [BigImages, SmallImages]);

   // 自动轮播逻辑
    useEffect(() => {
        const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 5000); // 5 秒间隔
        
        // 初始运行和监听窗口大小变化
        updateImages();
        window.addEventListener("resize", updateImages);

        // 清除事件监听器
        return () => {
          clearInterval(interval); 
          window.removeEventListener("resize", updateImages);
        }// 清理定时器
    }, [images.length]);

  return (
    <div className="product-page">
      {/* 产品名称及描述 */}
      <header className="product-header">
        <div className="product-title">
            <h1>ELEHEAR Beyond</h1>
            <h2>Hearing Aids</h2>
        </div>
        
        {/* <p>
          Bluetooth Rechargeable OTC Hearing Aids for Seniors<br />
          Superior Sound Quality Smart Hearing Aid with AI Noise Cancellation<br />
          Bluetooth Enabled & App Control
        </p> */}
      </header>

      {/* 轮播图 */}
      <div className="carousel-container">
        <div className="carousel">
          
          <img
            className="carousel-image"
            src={images[currentIndex]}
            alt={`Slide ${currentIndex + 1}`}
          />
        
          <div className="carousel-indicators">
            <button className="left-button" onClick={handlePrev}>
            </button>

              {images.map((_, index) => (
                <button
                  key={index}
                  className={`indicator ${
                    index === currentIndex ? "active" : ""
                  }`}
                  onClick={() => handleSelect(index)}
                >
                  {index + 1}
                </button>
              ))}

            <button className="right-button" onClick={handleNext}>
            </button>
          </div>
        </div>
      </div>

      {/* 功能描述 */}
      <section className="product-description">
        <h2>See All the Impressive<br /> Features Packed into <br />ELEHEAR Beyond</h2>
        <div className="title-sub">See All the Impressive Features Packed into ELEHEAR Beyond</div>
        <ul>
            <FeatureCardCom
                icon={icon[0]}
                title="Super Clear Sound"
                content={
                <>
                    Powered by <span className="highlight">VOCCLEAR® AI Technology</span> with maximum gain of <span className="highlight">up to 50 dB</span> and <span className="highlight">24 dB</span> noise attenuation, ELEHEAR<br /> Beyond is specially designed for individuals with mild to moderate hearing loss.<br />
                    <br />
                    Hearing aid delivers an exceptional listening experience through <span className="highlight">noise cancellation</span> and <span className="highlight">feedback control</span>, allowing<br /> you to enjoy naturally clear sounds without background noise or whistling.
                    <br />
                    <br />
                    This hearing aid ensures an immersive auditory experience for you.
                </>
                }
            />

            <FeatureCardCom
                icon={icon[1]}
                title="Customizable Smart Features"
                content={
                <>
                    These Bluetooth hearing aids come with the ELEHEAR smart app for both <span className="highlight">iOS</span> and <span className="highlight">Android</span> devices.
                    <br />
                    <br />
                    Offering customizable features like volume adjusting, AI translation, tinnitus masking, telephone speech enhancement<br /> settings, and user-customized compensation.
                    <br />
                    <br />
                    All in an intelligent way to tailor your auditory experience.
                </>
                }
            />

            <FeatureCardCom
                icon={icon[2]}
                title="Long-lasting Up to 100 Hours"
                content={
                <>
                    The rechargeable hearing aids and charging case provide a total of <span className="highlight">100 hours</span> of battery life for you to enjoy, which
                    <br />
                    brings immense convenience to your daily life.
                    <br />
                    The rechargeable hearing aids have a battery life of up to <span className="highlight">20 hours</span>, and the charging case offers an <span className="highlight">additional 4</span><br />
                     charging cycles
                    <br />
                    <br />
                    Say goodbye to the hassle of frequent battery charges, as the hearing aids keep pace with your active lifestyle.
                </>
                }
            />

            <FeatureCardCom
                icon={icon[3]}
                title="Easy to Use and Comfortable to Wear"
                content={
                <>
                    The hearing aids, designed for seniors, automatically turn on/off when taken out or placed back into the charging<br /> case.
                    <br />
                    <br />
                    With a lightweight design and Receiver-in-the-canal design, they are barely noticeable to others. 
                    <br />
                    <br />
                    The carefully crafted contour shape and soft materials conform to the unique shape of your ear, providing comfort for<br /> all-day wear.
                    <br />
                    <br />
                    Multiple dome sizes are included to fit ears of all sizes.
                </>
                }
            />

            <FeatureCardCom
                icon={icon[4]}
                title="ElePro Audiologist Remote Care Service"
                content={
                <>
                    The OTC hearing aids offer a worry-free experience. 
                    <br />
                    <br />
                    If you have any questions, please don't hesitate to contact us! 
                    <br />
                    <br />
                    Our after-sales support will ensure your satisfaction at every step!
                </>
                }
            />
        </ul>
      </section>

      {/* 购买按钮 */}
      {/* <div className="buy-now">
        <a
          href="https://www.amazon.com/dp/B0DGXQWPC9?maas=maas_adg_5A0FAE07CB440A41C1B0C8BBC692E6AF_afap_abs&ref_=aa_maas&tag=maas"
          target="_blank"
          rel="noopener noreferrer"
          className="buy-button"
        >
          Buy with Prime
        </a>
      </div> */}
    </div>
  );
};

export default ProductPageCom;
